import React from "react";
import "./Disclaimer.css";

interface DisclaimerProps {
  open: boolean;
  onClose: () => void;
}

const Disclaimer: React.FC<DisclaimerProps> = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div
      className="disclaimer-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="disclaimer-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="disclaimer-title"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <button
          className="disclaimer-close"
          onClick={onClose}
          aria-label="Close disclaimer"
          title="Close"
        >
          ×
        </button>

        <h2 id="disclaimer-title" className="disclaimer-title">
          Disclaimers
        </h2>

        <div className="disclaimer-content">
          <ol>
            <li>
              <strong>Legal or Contractual Authority</strong>
              <ul>
                <li>The JO Enterprise Chat responses are not legally binding, and do not constitute or convey legal advice. 
                    You should not act upon any JO Enterprise Chat responses or information without first seeking qualified 
                    professional guidance from JobsOhio’s legal counsel on your specific question or matter.</li>
              </ul>
            </li>

            <li>
              <strong>Accuracy & Reliability</strong>
              <ul>
                <li>JO Enterprise Chat responses are generated based on users’ permissions, available data, and programmed logic. 
                    While we strive for accuracy, we cannot guarantee that all information is complete, correct, or up to date.</li>
                <li>Users should verify any information provided by the JO Enterprise Chat before relying on its output.</li>
              </ul>
            </li>

            <li>
              <strong>IT & Security Disclaimer</strong>
              <ul>
                <li>Use of the JO Enterprise Chat is subject to JobsOhio’s IT Usage and AI Governance policies and processes. 
                    Misuse may result in access restrictions or disciplinary action.</li>
                <li>Users should review for any content produced by the JO Enterprise Chat remains a critical security measure.</li>
              </ul>
            </li>

            <li>
              <strong>HR Authority</strong>
              <ul>
                <li>The JO Enterprise Chat does not replace or take precedence over official Human Resources communications, 
                    employee handbooks, or direct guidance from Human Resources staff.</li>
                <li>Do not use the JO Enterprise Chat for issues involving workplace disputes, disciplinary matters, or 
                    sensitive personal circumstances. Users should contact HR directly.</li>
              </ul>
            </li>

            <li>
              <strong>Confidentiality & Data Handling</strong>
              <ul>
                <li>In compliance with the Standard of Conduct, do not share sensitive personal or confidential company information with the JO Enterprise Chat.</li>
              </ul>
            </li>

            <li>
              <strong>Compliance & Policy Alignment</strong>
              <ul>
                <li>The JO Enterprise Chat does not replace or take precedence over JobsOhio’s policies, processes, or compliance requirements.</li>
              </ul>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
